'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDeviceInfo = exports.reducers = exports.default = undefined;

var _selectors = require('./selectors');

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_selectors).default;
    }
});

var _deviceDetector = require('./deviceDetector');

Object.defineProperty(exports, 'getDeviceInfo', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_deviceDetector).default;
    }
});

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = {
    platform: _reducer2.default
};

exports.reducers = reducers;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-device-detection/dist/main/index.js
// module id = 178
// module chunks = 0